// extracted by mini-css-extract-plugin
export default {"home":"Home_home__SPTgp","homeContainer":"Home_homeContainer__4JGEb"};